<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-group">
        <div class="group-one" style="width: 220px">
          <a-range-picker
              v-model:value="rangePicker"
              :allowClear="false"
              :ranges="ranges"
              @change="handlePicker"
          />
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.mid"
              :dropdownMatchSelectWidth="false"
              :filterOption="tasknumberFilter"
              :maxTagCount="1"
              placeholder="被分配人"
              show-search
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.taskmember.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.type"
              placeholder="类型"
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.tasktype.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.status"
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.taskstatus.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.hname"
            :loading="searchLoading"
            placeholder="请输入房间名称"
            @search="getTableData"
        >
        </a-input-search>
      </div>
      <div class="lef-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
      <div
          class="lef-one"
          style="background-color: lightgoldenrodyellow; padding: 4px 20px"
      >
        <span
        >共个{{ cancel }}任务, 待分配{{
            all
          }},待处理,进行中,已完成,已取消2</span
        >
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one" @click="handleOpenModal">
        <a-button class="btn-primary">创建任务</a-button>
      </div>
      <!-- <div class="rig-one">
          <a-button><user-outlined />成员</a-button>
        </div> -->
      <!-- <div class="rig-one">
          <a-button><upload-outlined /></a-button>
        </div> -->
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :customRow="rowClick"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'type'">
        <span v-if="record.type == 1"> 保洁 </span>
        <span v-else-if="record.type == 2"> 维护 </span>
        <span v-else-if="record.type == 3"> 接待 </span>
        <span v-else-if="record.type == 4"> 客房服务 </span>
        <span v-else-if="record.type == 5"> 其他 </span>
      </template>
      <template v-if="column.key == 'date'">
        <span>{{ record.date }} {{ record.time }}</span>
      </template>
      <template v-if="column.key == 'status_text'">
        <div
            style="display: flex; align-items: center; justify-content: center"
        >
          <div
              v-if="record.status == 1"
              class="bar"
              style="background-color: #009999"
          >
            待分配
          </div>
          <div
              v-else-if="record.status == 2"
              class="bar"
              style="background-color: #0094ff"
          >
            待执行
          </div>
          <div
              v-else-if="record.status == 3"
              class="bar"
              style="background-color: #ff9900"
          >
            进行中
          </div>
          <div
              v-else-if="record.status == 4"
              class="bar"
              style="background-color: #333333"
          >
            已完成
          </div>
          <div v-else class="bar" style="background-color: #7f7f7f">已取消</div>
        </div>
      </template>
      <template v-if="column.key == 'order_no'">
        <a-button type="link">{{ record.order_no }}</a-button>
      </template>
    </template>
  </a-table>

  <!-- 添加任务 -->
  <AddTasks
      v-model:visible="visibleAdd"
      :form="addForm"
      :title="modalTitle"
      @confirm="handleOk"
  />

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      class="pagination"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />

  <!-- 任务详情 -->
  <TasksDetails
      v-model:visible="visibleDrawer"
      :taskId="taskId"
      @refresh="getTableData"
  ></TasksDetails>
</template>

<script>
import {onMounted, reactive, toRefs, watch} from "vue";
import {getSearchList, taskList} from "@/api/api";
import dayjs from "dayjs";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import AddTasks from "../../../../components/pms/landlord/tasks/Add.vue";
import TasksDetails from "../../../../components/pms/landlord/tasks/Details.vue";
import {log} from "util";
import {list} from "postcss";

export default {
  data() {
    return {
      all: 2,
      cancel: 3,
      complete: 4,
      doing: 0,
      unassigned: 0,
      undo: 0,
    };
  },
  computed: {
    list() {
      return list;
    },
  },
  methods: {log},
  components: {
    AddTasks,
    TasksDetails,
  },
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        hname: "",
        mid: [],
        status: [],
        type: [],
        date: "",
        start: 0,
        limit: store.getters.getPageSize,
      },
      rangePicker: [],
      visiblePopover: false,
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
        taskmember: {},
        taskstatus: {},
        tasktype: {},
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handlePicker(_params, value) {
        search.searchForm.date = value[0] + "," + value[1];
        table.getTableData();
      },
      handleReset() {
        search.searchForm.hname = "";
        search.rangePicker = [];
        search.searchForm.mid = [];
        search.searchForm.status = [];
        search.searchForm.type = [];
        search.searchForm.date = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },

      tasknumberFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "任务时间",
          dataIndex: "date",
          key: "date",
          align: "center",
        },
        {
          title: "房间",
          dataIndex: "hname",
          key: "hname",
          align: "center",
          ellipsis: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "房态",
          dataIndex: "houseState",
          key: "houseState",
          align: "center",
        },
        {
          title: "指派人",
          dataIndex: "mname",
          key: "mname",
          align: "center",
          ellipsis: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          align: "center",
        },
        {
          title: "开始时间",
          dataIndex: "start_time",
          key: "start_time",
          align: "center",
        },
        {
          title: "结束时间",
          dataIndex: "complete_time",
          key: "complete_time",
          align: "center",
        },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
          align: "center",
        },
        {
          title: "价格",
          dataIndex: "amount",
          key: "amount",
          align: "center",
        },
        {
          title: "描述",
          dataIndex: "remark",
          key: "remark",
          align: "center",
          ellipsis: true,
          width: 200,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "反馈",
          dataIndex: "feedback",
          key: "feedback",
          align: "center",
          ellipsis: true,
          width: 200,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
      ],
      getTableData() {
        search.searchLoading = true;
        taskList({
          hname: search.searchForm.hname,
          mid: search.searchForm.mid ? search.searchForm.mid : "",
          type: search.searchForm.type ? search.searchForm.type : "",
          status: search.searchForm.status ? search.searchForm.status : 0,
          date: search.searchForm.date,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
              this.cancel = res.data.count_list.cancel;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      // table 点击行
      rowClick(record) {
        return {
          onClick: () => {
            details.getTaskDetail(record.id);
          },
          style: "cursor: pointer;",
        };
      },
    });

    // 详情
    const details = reactive({
      visibleDrawer: false,
      taskId: 0,
      detailsData: {
        rela: [],
      },
      getTaskDetail(id) {
        details.visibleDrawer = true;
        details.taskId = id;
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "创建任务",
      visibleAdd: false,
      handleOpenModal() {
        modal.modalTitle = "创建任务";
        modal.visibleAdd = true;
        modal.addForm = null;
      },
      handleOk() {
        modal.visibleAdd = false;
        table.getTableData();
      },
      addForm: {},
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(details),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}

.rowClick {
  cursor: pointer;
}
</style>
